import React, { useMemo } from 'react';
import SeriesRadarChart, {
  seriesItemsFromLegendMaps,
  ASSESSMENT_SERIES_FILTER_MAX,
} from 'js/components/Charts/SeriesRadarChart';
import {
  ASSESSMENT_SERIES_PALETTE,
  buildAssessmentRadarSeries,
} from './assessment-radar-series';

function AssessmentSeriesRadarChart({
  assessments = [],
  dataMap,
  categoryLookups,
  categoryColorMap,
  seriesPalette = ASSESSMENT_SERIES_PALETTE,
  legendHeading = 'Assessments',
  resetPinKey,
  includeCombined = true,
  limit = null,
  includeEmptyAsDisabled = true,
}) {
  const { legendFields, seriesDataMaps } = useMemo(
    () =>
      buildAssessmentRadarSeries(dataMap, assessments, {
        includeCombined,
        combinedQuestionSets: dataMap?.questionSets ?? {},
        limit,
        includeEmptyAsDisabled,
      }),
    [assessments, dataMap, includeCombined, includeEmptyAsDisabled, limit]
  );

  const series = useMemo(
    () => seriesItemsFromLegendMaps(legendFields, seriesDataMaps),
    [legendFields, seriesDataMaps]
  );

  const assessmentKeys = (assessments ?? []).map((item) => item.id).join(',');

  return (
    <SeriesRadarChart
      questionSets={dataMap?.questionSets ?? {}}
      series={series}
      categoryLookups={categoryLookups}
      categoryColorMap={categoryColorMap}
      legendHeading={legendHeading}
      seriesPalette={seriesPalette}
      resetPinKey={resetPinKey ?? assessmentKeys}
      enableSeriesFilter
      maxSeries={ASSESSMENT_SERIES_FILTER_MAX}
    />
  );
}

export default AssessmentSeriesRadarChart;
